import { Glyph } from "../../types";

const SvgLogo1: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 195" {...props}>
      <polygon
        fill="#fff"
        points="192.6 .5 97.9 106.1 2 .8 2 194.5 39.1 194.5 38.8 90.9 97.8 159.3 156.6 90.9 155.8 159.3 192.6 159.3 192.6 .5"
      />
      <polygon
        fill="#fff"
        points="225.2 6.1 296.7 134.7 296.7 194.5 335.7 194.5 335.7 134.7 384 41.3 344.7 41.3 316.6 102.5 268.1 6.1 225.2 6.1"
      />
      <g>
        <path
          fill="#fff"
          d="M454.7,42.2h17.9c19.7,0,30.6,10.6,30.6,27.1s-11,27.1-30.6,27.1h-6.8v17h-11.1V42.2ZM472.2,86.7c14,0,19.7-6.6,19.7-17.4s-5.8-17.4-19.7-17.4h-6.4v34.8h6.4Z"
        />
        <path
          fill="#fff"
          d="M586.9,113.4h-12.8l-12.8-18.7c-2,.2-4,.4-6,.4h-6.7v18.3h-11.1V42.2h17.8c19.7,0,30.7,10.3,30.7,26.6s-4.9,18.5-14.2,22.6l15.1,22ZM555,85.5c14.1,0,19.8-6.2,19.8-16.7s-5.9-16.9-19.8-16.9h-6.3v33.6h6.3Z"
        />
        <path
          fill="#fff"
          d="M618.6,77.8c0-21.2,16.3-36.5,36.7-36.5s36.6,15.3,36.6,36.5-16.3,36.5-36.6,36.5-36.7-15.3-36.7-36.5M680.7,77.8c0-15.2-10.5-26.6-25.3-26.6s-25.4,11.4-25.4,26.6,10.6,26.6,25.4,26.6,25.3-11.4,25.3-26.6"
        />
        <path
          fill="#fff"
          d="M718,102.3l9-5.5c2.5,4.5,5.4,7.6,10.7,7.6s9.8-2.8,9.8-11.1v-51.1h11.1v51.3c0,14.1-8.5,20.8-20.4,20.8s-16.9-5.4-20.2-12"
        />
      </g>
      <polygon
        fill="#fff"
        points="796.3 42.2 841.6 42.2 841.6 51.9 807.4 51.9 807.4 79.6 837.7 79.6 837.7 89.1 807.4 89.1 807.4 103.6 843 103.6 843 113.4 796.3 113.4 796.3 42.2"
      />
      <path
        fill="#fff"
        d="M874.9,77.8c0-21.2,16.3-36.4,36.5-36.4s22.2,4.7,28.5,14.1l-8.5,6.1c-4-6.2-10.7-10.3-20-10.3-14.8,0-25.2,11.3-25.2,26.5s10.5,26.6,25.2,26.6,16.4-4.4,21-11.2l8.5,6c-6.2,9.4-16.2,15.2-29.5,15.2-20.2,0-36.5-15.3-36.5-36.5"
      />
      <polygon
        fill="#fff"
        points="968.7 42.2 968.7 51.9 989.9 51.9 989.9 113.4 1000.9 113.4 1000.9 51.9 1022 51.9 1022 42.2 968.7 42.2"
      />
      <rect fill="#be2a3f" x="454.7" y="138.1" width="225.7" height="56.4" />
      <path
        fill="#fff"
        d="M488.4,164.3l-2.7-1.5-2.1-1.3c-1.2-.8-1.7-1.3-1.8-1.4-.9-1.1-1.4-2.1-1.4-3.1,0-1.4.5-2.5,1.5-3.4,1-.9,2.3-1.3,3.9-1.3s4.3.9,6.2,2.8l.2.2,3.3-3.3.2-.2-.2-.2c-2.6-2.8-5.9-4.1-9.7-4.1s-5.5.9-7.5,2.6c-2,1.7-3,4-3,7s.8,4.2,2.4,5.9c1.5,1.7,3.9,3.4,7.1,4.9,4.7,2.4,7.1,4.8,7.1,7.4s-.5,2.5-1.6,3.5c-1.1,1-2.4,1.5-4.1,1.5s-3.3-.3-4.6-1c-1.3-.7-2.7-1.8-4.2-3.3l-.2-.2-3.5,3.5.2.2c1.3,1.7,3,3,5.2,4.1,2.2,1,4.6,1.6,7.1,1.6s5.8-.9,7.7-2.8c2-1.9,3-4.3,3-7.1,0-4.1-2.9-7.8-8.5-10.9"
      />
      <path
        fill="#fff"
        d="M523.9,173h-12.7l6.3-15.1,6.4,15.1ZM518.1,147.5h-.8l-16,36.5v.2c0,0,.3.6.3.6h4.8l2.9-6.9h16.8l2.9,6.9h4.9l.4-.6-16-36.4v-.2Z"
      />
      <polygon
        fill="#fff"
        points="541.7 184.7 546.6 184.7 546.6 171.1 559.9 171.1 559.9 166.3 546.6 166.3 546.6 152.7 562.4 152.7 562.4 147.9 541.7 147.9 541.7 184.7"
      />
      <polygon
        fill="#fff"
        points="570.7 184.7 591.4 184.7 591.4 179.9 575.7 179.9 575.7 171.9 588.9 171.9 588.9 167.1 575.7 167.1 575.7 152.7 591.4 152.7 591.4 147.9 570.7 147.9 570.7 184.7"
      />
      <polygon
        fill="#fff"
        points="597.1 152.7 609.4 152.7 609.4 184.7 614.3 184.7 614.3 152.7 626.6 152.7 626.6 147.9 597.1 147.9 597.1 152.7"
      />
      <polygon
        fill="#fff"
        points="661.1 147.9 656.2 147.9 645.9 166.3 635.5 148.1 635.4 147.9 630.4 147.9 630 148.5 643.3 171.5 643.3 184.7 648.2 184.7 648.2 171.5 661.4 148.7 661.5 148.5 661.1 147.9"
      />
    </svg>
  );
};

export default SvgLogo1;
